import { render, staticRenderFns } from "./NewsChanger.vue?vue&type=template&id=5c66ed3e"
import script from "./NewsChanger.vue?vue&type=script&lang=js"
export * from "./NewsChanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports